import { useSuspenseQuery } from '@tanstack/react-query';

import { cacheKeys } from '../config';
import { assertionClient } from '../client/assertionClient';

type Options = {
};

const defaultOptions: Partial<Options> = {
};

export const useAssertions = (params: Assertions.GetListParams = {}, options: Partial<Options> = defaultOptions) => {
  const { data: { data } = {}, ...rest } = useSuspenseQuery({
    queryKey: [cacheKeys.getAssertions, params],
    queryFn: () => assertionClient.getAssertions(params),
  });

  return {
    ...rest,
    count: data?.count || 0,
    assertions: data?.results || [],
  };
};

export const useAssertionBgImgs = () => {
  const { data: { data } = {}, ...rest } = useSuspenseQuery({
    queryKey: [cacheKeys.getAssertionImages],
    queryFn: assertionClient.getAssertionImages,
  });

  return {
    ...rest,
    assertionsBgImgs: data?.results || [],
  };
};
